import React, { Component } from "react";

import { connect } from "react-redux";
import history from "../../history";

import { NotificationManager } from "react-notifications";

// import Capthca from '../../components/captcha';

class ForgotPasswordForm extends Component {
  constructor(props, context) {
    super(props);
    this.state = {
      email: props.email,
      username: props.username,
      error: "",
      password: "",
      loading: false,
      passwordForget: false,
      resetEmail: "",
      requestEnable: false,
      newPassword: "",
      verificationCode: "",
      repeatPassword: ""
      // captchaSuccess: false
    };

    this.handleChange = fieldName => event => {
      let obj = Object.assign({});
      obj[fieldName] = event.target.value;
      this.setState(obj);
    };
  }

  onCapthcaSuccess() {
    this.setState({
      captchaSuccess: true
    });
  }

  submitChangePassword() {
    this.props
      .sendVerificationCode(this.state.resetEmail, this.props.userPool)
      .then(res => {
        NotificationManager.success("Reset Password Code Sent");
        this.setState({
          loading: false,
          resetEmail: "",
          requestEnable: true
        });
      })
      .catch(err => {
        NotificationManager.success("Reset Password Error");
        this.setState({
          loading: false,
          resetEmail: ""
        });
      });
  }

  resetPassword() {
    this.setState({
      loading: true
    });

    this.props
      .setPassword(
        this.state.username.toLowerCase(),
        this.state.verificationCode,
        this.state.newPassword
      )
      .then(res => {
        this.setState({
          loading: false
        });
        NotificationManager.success("Password Changed");
        // history.push('/login')
      })
      .catch(err => {
        // let message = strings.INVALID_VERIFICATION_CODE
        // if (err.toString().length !== 0) {
        // 	message = err.toString()
        // }
        NotificationManager.error(err);
        this.setState({
          loading: false
        });
      });
  }

  requestEnable() {
    this.setState({
      requestEnable: true
    });
  }

  render() {
    const { classes, theme } = this.props;
    return (
      <div className="m-grid m-grid--hor m-grid--root m-page">
        <div
          className="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--singin m-login--2 m-login-2--skin-2"
          id="m_login"
          style={{
            backgroundImage:
              "url(../../../assets/app/media/img//bg/new-background.png)",
            height: "100vh"
          }}
        >
          <div className="m-grid__item m-grid__item--fluid	m-login__wrapper">
            <div className="m-login__container">
              <div className="m-login__logo">
                <a href="#">
                  <img src="../../../assets/app/media/img/logos/logo.png" />
                </a>{" "}
              </div>{" "}
              <div className="m-login__forget-password">
                <div className="m-login__head">
                  <h3 className="m-login__title">Forgotten Password </h3>{" "}
                  {this.state.requestEnable == true ? (
                    <div className="m-login__desc">
                      Enter reset code to reset your password :
                    </div>
                  ) : (
                    <div className="m-login__desc">
                      Enter your email to reset your password:
                    </div>
                  )}
                </div>

                {this.state.requestEnable == false ? (
                  <form className="m-login__form m-form" action="">
                    <div className="form-group m-form__group">
                      <input
                        onChange={this.handleChange("resetEmail")}
                        value={this.state.resetEmail}
                        className="form-control m-input"
                        type="email"
                        placeholder="Email"
                        autocomplete="off"
                      />
                    </div>{" "}
                    <div className="m-login__form-action">
                      <div
                        onClick={() => this.submitChangePassword()}
                        className="btn btn-success m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primary"
                      >
                        Request{" "}
                      </div>{" "}
                      & nbsp; & nbsp;{" "}
                      <button
                        onClick={() => history.push(`/login`)}
                        id="m_login_forget_password_cancel"
                        className="btn btn-outline-success btn-outline-focus m-btn m-btn--pill m-btn--custom  m-login__btn"
                      >
                        Cancel{" "}
                      </button>{" "}
                    </div>{" "}
                  </form>
                ) : (
                  <form className="m-login__form m-form" action="">
                    <div className="form-group m-form__group">
                      <input
                        onChange={this.handleChange("verificationCode")}
                        value={this.state.verificationCode}
                        className="form-control m-input"
                        type="text"
                        placeholder="Reset Code"
                        autocomplete="off"
                      />
                    </div>{" "}
                    <div className="form-group m-form__group">
                      <input
                        onChange={this.handleChange("newPassword")}
                        value={this.state.newPassword}
                        className="form-control m-input"
                        type="password"
                        placeholder="New Password"
                        autocomplete="off"
                      />
                    </div>{" "}
                    <div className="form-group m-form__group">
                      <input
                        onChange={this.handleChange("repeatPassword")}
                        value={this.state.repeatPassword}
                        className="form-control m-input"
                        type="password"
                        placeholder="Repeat Password"
                        autocomplete="off"
                      />
                    </div>{" "}
                    <div className="m-login__form-action">
                      <button
                        disabled={
                          this.state.newPassword != this.state.repeatPassword
                        }
                        onClick={() => this.resetPassword()}
                        className="btn btn-success m-btn m-btn--pill m-btn--custom m-btn--air m-login__btn m-login__btn--primary"
                      >
                        Reset{" "}
                      </button>{" "}
                      & nbsp; & nbsp;{" "}
                      <button
                        onClick={() => history.push(`/login`)}
                        id="m_login_forget_password_cancel"
                        className="btn btn-outline-success btn-outline-focus m-btn m-btn--pill m-btn--custom  m-login__btn"
                      >
                        Cancel{" "}
                      </button>{" "}
                    </div>{" "}
                  </form>
                )}
              </div>{" "}
            </div>{" "}
          </div>{" "}
        </div>{" "}
      </div>
    );
  }
}

const mapStateToProps = state => {
  let username = "";
  if (state.cognito.user) {
    username = state.cognito.user.getUsername();
  } else if (state.cognito.userName) {
    username = state.cognito.cache.userName;
  }
  return {
    username,
    cognitoState: state.cognito.state,
    email: state.cognito.cache.email,
    config: state.cognito.config,
    userPool: state.cognito.userPool,
    language: state.language
  };
};

export default connect(
  mapStateToProps,
  null
)(ForgotPasswordForm);
